import { MultiSelect, ISelectItem } from "@react-gcc-eds/core";
import { useState, useEffect } from "react";
import { useStore } from "../../../../store";
import { MultiSelectLimitedPills } from "../../../shared/multiselect-limited-pills";

export const InternalPurchaseOrdersFilterDropDown = ({
  onChange,
  selectedItems
}: {
  onChange: (selectedItem: ISelectItem<string>[]) => void;
  selectedItems: ISelectItem<string>[];
}) => {
  const [state] = useStore();
  const [noAvailablePurchaseOrderNumbers, setNoAvailablePurchaseOrderNumbers] = useState<boolean>();
  const {
    internalItemCreationDateBarsAvailablePurchaseOrderNumbers: fetchingPurchaseOrderNumbers,
    internalItemCreationDateBarsMetric: fetchingItemCreationDateBarsMetrics
  } = state.fetchingData.metrics;

  const disableDropdown =
    noAvailablePurchaseOrderNumbers ||
    fetchingPurchaseOrderNumbers === true ||
    fetchingItemCreationDateBarsMetrics === true;

  useEffect(() => {
    const noAvailablePurchaseOrderNumbers =
      state.metrics.internalItemCreationDateBarsAvailablePurchaseOrderNumbers === undefined ||
      state.metrics.internalItemCreationDateBarsAvailablePurchaseOrderNumbers.length === 0;

    setNoAvailablePurchaseOrderNumbers(noAvailablePurchaseOrderNumbers);
  }, [state.metrics.internalItemCreationDateBarsAvailablePurchaseOrderNumbers]);

  return (
    <div className="pill-filter-wrapper">
      <MultiSelect
        key="poDropDown"
        items={
          state.metrics.internalItemCreationDateBarsAvailablePurchaseOrderNumbers
            ? (
                state.metrics.internalItemCreationDateBarsAvailablePurchaseOrderNumbers as string[]
              ).map(poNumber => ({ value: poNumber, title: poNumber }) as ISelectItem)
            : []
        }
        disabled={disableDropdown}
        onChange={(items: ISelectItem[]) => onChange(items)}
        selectedItems={selectedItems}
        placeholder={
          noAvailablePurchaseOrderNumbers
            ? "No Purchase Orders"
            : fetchingPurchaseOrderNumbers || fetchingItemCreationDateBarsMetrics
              ? "Fetching data"
              : "Select Purchase Order"
        }
        searchable
        withPills={false}
      />
      <MultiSelectLimitedPills
        data={selectedItems}
        onRemove={onChange}
        isDisabled={disableDropdown}
      />
    </div>
  );
};
